import React, { ReactElement, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { clearSearchResult, getAscendantsRequested, getFilteredSearchResultsRequested, moveWalletRequested } from "redux/wallet/walletSlice";
import { closeDialog, openDialog } from "redux/dialog/dialogSlice";
import { handleScroll } from "services/utils";

import { Box, Button, InputAdornment, MenuItem, TextField, Typography } from "@mui/material";
import FontAwesomeIcon from "../FontAwesomeIcon";

import styles from "./styles.module.scss"
import { Translate } from "react-redux-i18n";

export default function MoveWallet(): ReactElement {
  const dispatch = useAppDispatch();
  const selectedWallet = useAppSelector(state => state.dialog.dialogData)
  const ancestors = useAppSelector(state => state.wallet.ancestors)
  const searchResults = useAppSelector(state => state.wallet.searchResults)
  const authId = useAppSelector(state => state.auth.authWallet?.id)
  const selectedWalletParent = ancestors?.find(item => item.id === selectedWallet.parent_id)
  const walletTypes = useAppSelector(state => state.config.walletType)
  const [value, setValue] = useState<string>("");
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
  const [itemsToLoad, setItemsToLoad] = useState<number>(10)
  const [selectedNewParent, setSelectedNewParent] = useState<any>(undefined)
  const [blockMovement, setBlockMovement] = useState<boolean>(true)

  const handleChange = (value: string) => {
    if (value.length > 0) {
      setValue(value)
      dispatch(getFilteredSearchResultsRequested({
        id: authId,
        params: {
          username: value
        }
      }))
      setIsMenuOpen(true)
    } else {
      dispatch(clearSearchResult())
      setItemsToLoad(10)
      setIsMenuOpen(false)
      setValue("")
      setSelectedNewParent(undefined)
      setBlockMovement(true)
    }
  }

  const handleItemClick = (value: any) => {
    setValue(value.name)
    setSelectedNewParent(value)
    setIsMenuOpen(false)
  }

  const handleMoveClick = () => {
    dispatch(openDialog({ payload: { "wallet_id": selectedWallet.id, data: { "parent_id": selectedNewParent.id }, "oldParent_id": selectedWalletParent?.id }, type: "confirmMove" }))
  }

  useEffect(() => {
    dispatch(getAscendantsRequested(selectedWallet.id))
  }, [selectedWallet])

  useEffect(() => {
    if (selectedNewParent) {
      const selectedNewParentWalletType = walletTypes?.find(item => item.id === selectedNewParent.wallet_type?.id)
      if (selectedNewParentWalletType?.can_contain_wallettype?.includes(selectedWallet.wallet_type.id)) {
        setBlockMovement(false)
      } else {
        setBlockMovement(true)
      }
    }
  }, [selectedNewParent])

  return (
    <Box className={styles.moveWalletContainer}>
      <Box className={styles.moveWalletInfoContainer}>
        <Typography className={styles.moveWalletInfoLabel}>
          <span>
            <Translate value="moveWallet.selectedWallet" /> :
          </span>
          <span>
            {selectedWallet.name} ({selectedWallet.wallet_type.label})
          </span>
        </Typography>

        <Typography className={styles.moveWalletInfoLabel}>
          <span>
            <Translate value="moveWallet.parentWallet" /> :
          </span>
          <span>
            {selectedWalletParent && selectedWalletParent.name}
            &nbsp;({selectedWalletParent && selectedWalletParent.wallet_type?.label})
          </span>
        </Typography>

        <Box className={styles.newParentContainer}>
          <Typography className={styles.newParentLabel}>
            <Translate value="moveWallet.newParent" /> :
          </Typography>
          <Box className={styles.newParentInput}>
            <TextField
              value={value}
              size="small"
              fullWidth
              name="username"
              placeholder="Search"
              InputProps={{
                startAdornment:
                  <InputAdornment
                    position="start"
                    className={styles.inputAdornment}>
                    <FontAwesomeIcon name="magnifying-glass" type="fas" />
                  </InputAdornment>,
              }}
              onChange={(e) => handleChange(e.target.value)}
              className={[styles.textfield, "form-label"].join(" ")}
            />
            {isMenuOpen && searchResults &&
              <Box onScroll={(e) => handleScroll(e, setItemsToLoad, itemsToLoad, 10)} className={styles.resultMenu}>
                {searchResults &&
                  searchResults.slice(0, itemsToLoad).map(result =>
                    <MenuItem
                      onClick={() => handleItemClick(result)}
                      key={result.id}
                      className={styles.resultContainer}
                    >
                      {result.name} - {result.wallet_type?.label}
                    </MenuItem>
                  )
                }
              </Box>
            }
          </Box>
        </Box>
      </Box>
      <Box className={styles.moveButtonContainer}>
        {blockMovement && selectedNewParent &&
          <Typography className={styles.errorMessage}>
            <Translate value="moveWallet.moveDenied" />
          </Typography>
        }
        <Button
          disabled={selectedNewParent && !blockMovement ? false : true}
          variant="contained"
          color="success"
          onClick={() => handleMoveClick()}
        >
          <Translate value="moveWallet.moveWallet" />
        </Button>
      </Box>
    </Box>
  )
}

export function ConfirmMove(): ReactElement {
  const dispatch = useAppDispatch();
  const dialogData = useAppSelector(state => state.dialog.dialogData)
  // const authId = useAppSelector(state => state.auth.authWallet?.id)

  const handleMoveConfirmClick = () => {
    dispatch(moveWalletRequested(dialogData))
    dispatch(closeDialog())
    // authId && dispatch(getWalletRequested({ action: "new-update", id: authId }))
  }

  return (
    <Box className={styles.confirmMoveContainer}>
      <Typography className={styles.confirmMoveLabel}>
        <Translate value="moveWallet.confirmMove" />
      </Typography>
      <Box className={styles.buttonsContainer}>
        <Button
          variant="contained"
          color="success"
          onClick={() => handleMoveConfirmClick()}
        >
          <Translate value="coupon.proceed" />
        </Button>
        <Button
          onClick={() => dispatch(closeDialog())}
          variant="contained"
          color="error"
        >
          <Translate value="coupon.close" />
        </Button>
      </Box>
    </Box>
  )
}